import * as React from 'react'

import { PricingPriceBlock } from 'Pages/Pricing/@components'


export default function priceColumn(name, label, showStock, stockKey, minWidth, customTooltip = false, diff, retailer, siteID, productID ) {
	return {
		name: name, label: label,
		options: {
			filter: false,
			customBodyRowRenderLite: (value, { currency, ...dataRow }) => {
				const diffPrice = dataRow[diff]
				const retailerPrice = dataRow[retailer]
				const stock = showStock ? dataRow[stockKey] : null

				const priceTooltip = customTooltip ?
					'Your minimum price during the selected period.'
					: ''

				const stockTooltip = customTooltip ?
					['In stock at least once during the selected period', 'Out of stock for the entire period']
					: ''

				return <PricingPriceBlock
					price={value}
					priceTooltip={priceTooltip}
					currency={currency}
					diff={diffPrice}
					retailer={retailerPrice}
					siteID={dataRow[siteID]}
					productID={dataRow[productID]}
					stock={stock}
					stockTooltip={stockTooltip}
					propsContainer={{sx: {minWidth: minWidth}}}
					reverse
				/>
			}
		}
	}
}